<template>



  <v-dialog v-model="loginFormDialog" max-width="250"
  persistent>
    <v-card>
      <v-progress-linear
      indeterminate
        :active="loading"
      color="primary"
    ></v-progress-linear>
      <v-card-title class="headline">
        <v-icon class="pr-2" color="primary">mdi-lock-outline</v-icon>
        Login
      </v-card-title>
      <v-form ref="form" @submit.prevent="attemptLogin" autocomplete="on">
      <v-card-text>
        <v-fade-transition>
          <div class="red--text text-overline">{{loginFailMessage}}</div>
        </v-fade-transition>



          <validation-provider rules="required|email" v-slot="{ errors }">
          <v-text-field v-model="email" label="Email" type="text" name="email"

          :error-messages="errors">
          </v-text-field>
          </validation-provider>

          <v-text-field v-model="password"

          name="password" label="Password"



          type="password" hint="At least 8 characters"

          ></v-text-field>



      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text type="submit">
          Login
        </v-btn>
      </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>



</template>




<script>
  import axios from 'axios';
  import router from '@/router'
  import { ValidationProvider, extend } from 'vee-validate';
  import { required, email } from 'vee-validate/dist/rules';

  extend('required', {
    ...required,
  message: 'This field is required'
  });

  extend('email', {
    ...email,
    message: 'Email must be valid',
  })

  export default {
    data() {
        return {
          email: '',
          password: '',
          loading: false,
          loginFailMessage:'',

        }
      },
      name: 'loginForm',

      created() {

      },
      components: {
        ValidationProvider,

      },
      props: {

      },
      computed: {
        loginFormDialog: {
          get() {
              return !this.$store.getters.isUserAuthentificated;
            },
            set() {

            }
        },

      },
      methods: {
        getConfig(){
          let that = this
          let link = this.$store.getters.userAuthServer
          axios.get(link + '/app/get_config_file', {})
          .then(response => {
            if (response.status == 200 && response.data.status == 'success') {
              that.$store.dispatch('updateConfig', response.data.config)
            }

          })
          .catch(function () {
            that.loginFailMessage = 'Config Failed'
            that.loading = false
          })
        },

        showKeyboard({ object }) {
                   if (object.android) {
                       setTimeout(() => {
                           object.focus();

                       }, 10);
                   } else {
                       object.focus();
                   }
               },

        attemptLogin() {
            this.loading = true
            let that = this
            let link = this.$store.getters.userAuthServer
            let payload = {
              'email': this.email,
              'password': this.password
            }
            axios.post(link + '/api/login', payload)

            .then(response => {
              if (response.status == 200 && response.data.status == 'success') {
                that.$store.dispatch('updateisUserAuthentificated', true)
                that.$store.dispatch('updateEstaGroup', response.data.user.establishments)

                that.$store.dispatch('updateUserActive', {
                  'name':response.data.user.name,
                  'role':response.data.user.role,
                  'initials':response.data.user.initials
                })
                that.$store.dispatch('updatetokenAuthServer', {
                  'access_token': response.data.access_token,
                  'token_type': response.data.token_type,
                  'expires_in': response.data.expires_in
                })
                that.loading = false
                that.loginFailMessage = ''

            //this.getConfig()
            router.push(this.$store.state.previousPage)
              }

            })
            .catch(function () {
              that.loginFailMessage = 'Login Failed'
              that.loading = false
            })
          },


      },

  }

</script>


<style>
</style>
